var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.active === true)?_c('el-tag',{attrs:{"type":"success","size":"mini"}},[_vm._v("Ativo")]):(_vm.active === false)?_c('el-tag',{attrs:{"type":"danger","size":"mini"}},[_vm._v("Inativo")]):_c('span',[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }